import styles from './BigPlayButton.module.css'

interface Props {
  onClick: () => void
  visible: boolean
}

export function BigPlayButton({ onClick, visible }: Props) {
  if (!visible) return null
  return (
    <button type="button" className={styles.bigPlay} onClick={onClick} aria-label="Play">
      <span className={styles.halo} aria-hidden />
      <svg viewBox="0 0 80 80" width="80" height="80" aria-hidden>
        <defs>
          <linearGradient id="pvPlayGrad" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#e11d2e" />
            <stop offset="100%" stopColor="#ff4d5a" />
          </linearGradient>
        </defs>
        <circle cx="40" cy="40" r="38" fill="url(#pvPlayGrad)" opacity="0.95" />
        <circle cx="40" cy="40" r="38" fill="none" stroke="rgba(255,255,255,0.25)" strokeWidth="1.5" />
        <path d="M33 26.5v27l23-13.5-23-13.5z" fill="#fff" />
      </svg>
    </button>
  )
}
